import React from 'react';

interface SpotlightEffectProps {
  parallaxOffset?: { x: number; y: number };
}

export const SpotlightEffect: React.FC<SpotlightEffectProps> = ({ parallaxOffset = { x: 0, y: 0 } }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        className="absolute top-1/2 left-1/2 w-[700px] h-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20 blur-[120px] animate-spotlight-drift"
        style={{
          background: 'radial-gradient(circle, hsl(190 100% 50% / 0.2) 0%, transparent 70%)',
          animationTimingFunction: 'ease-in-out',
          transform: `translate(calc(-50% + ${parallaxOffset.x * 40}px), calc(-50% + ${parallaxOffset.y * 35}px))`,
          transition: 'transform 0.3s ease-out',
        }}
      />
    </div>
  );
};
